import React from 'react';

//Slick Slider
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { NavLink } from 'react-router-dom';

//Slider image
import SliderImage from '../Img/Slider-Home/tadilat-nedir.jpg';
import SliderImage2 from '../Img/Slider-Home/IMG-20230628-WA0040.jpg';
import SliderImage3 from '../Img/Slider-Home/IMG-20230628-WA0074.jpg';
import SliderImage4 from '../Img/Slider-Home/residential_construction.jpg';
import SliderImage5 from '../Img/Slider-Home/IMG-20230628-WA0043.jpg';
import SliderImage6 from '../Img/Slider-Home/IMG-20230628-WA0052.jpg';


//Arrows
import Next from '../Icons/Next';
import Prev from '../Icons/Prev';

//Styles
import './PortfolioSlider.scss'

function PortfolioSlider(props){

    //Custom arrows
    const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
        <button
          {...props}
          className={
            "slick-prev slick-arrow" +
            (currentSlide === 0 ? " slick-disabled" : "")
          }
          aria-hidden="true"
          aria-disabled={currentSlide === 0 ? true : false}
          type="button"
          id="prevSlide"
        >
          <Prev />
        </button>
      );

      const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
        <button
          {...props}
          className={
            "slick-next slick-arrow" +
            (currentSlide === slideCount - 1 ? " slick-disabled" : "")
          }
          aria-hidden="true"
          aria-disabled={currentSlide === slideCount - 1 ? true : false}
          type="button"
          id="nextSlide"
        >
          <Next />
        </button>
      );

    const settings ={
        dots:false,
        arrows:true,
        prevArrow:<SlickArrowLeft />,
        nextArrow:<SlickArrowRight />,
        autoplay:false,
        slidesToShow:3,
        slidesToScroll:3,
        variableWidth:true,
        responsive: [
            {
              breakpoint: 1100,
              settings: {
                variableWidth:false
              }
            },
            {
              breakpoint:950,
              settings: {
                slidesToShow:2,
                slidesToScroll:2,
                variableWidth:false
              }
            },
            {
              breakpoint:500,
              settings: {
                slidesToShow:1,
                slidesToScroll:1,
                variableWidth:false
              }
            }
          ]
    }
    function scrollToTop(){
      window.scrollTo({top:0});
    }

    return(
        <div className="portfolioSlider">
            <Slider {...settings}>
                <div className="slide">
                  <div className="content">
                  <img src={SliderImage} alt="portfolio-example" />
                    <div className="text">
                    <p>Restorations</p>
                        <p>Check out our Portfolio</p>

                        

                        <NavLink to="/portfolio" onClick={() => scrollToTop()}>Find More</NavLink>
                    </div>  
                  </div>

                </div>

                <div className="slide">
                  <div className="content">
                  <img src={SliderImage2} alt="portfolio-example" />
                    <div className="text">
                        <p>Concept Designing</p> 
                        <p>Check out our Portfolio</p>
                       
                        <NavLink to="/portfolio" onClick={() => scrollToTop()}>Find More</NavLink>
                    </div>  
                  </div>

                </div>

                
                <div className="slide">
                  <div className="content">
                  <img src={SliderImage3} alt="portfolio-example" />
                    <div className="text">
                        <p>Warehouses Construction</p>
                        <p>Check out our Portfolio</p>
                        

                       
                        <NavLink to="/portfolio" onClick={() => scrollToTop()}>Find More</NavLink>
                    </div>  
                  </div>

                </div>

                
                <div className="slide">
                  <div className="content">
                  <img src={SliderImage4} alt="portfolio-example" />
                    <div className="text">
                        <p>Residential Construction</p>
                        <p>Check out our Portfolio</p>
                        
                        <NavLink to="/portfolio" onClick={() => scrollToTop()}>Find More</NavLink>
                    </div>  
                  </div>

                </div>

                <div className="slide">
                  <div className="content">
                  <img src={SliderImage5} alt="portfolio-example" />
                    <div className="text">
                        <p>Housing Construction</p>
                        {/* <h5>Housing Construction</h5> */}

                        <p>Check out our Portfolio</p>
                        <NavLink to="/portfolio" onClick={() => scrollToTop()}>Find More</NavLink>
                    </div>  
                  </div>

                </div>

                
                <div className="slide">
                  <div className="content">
                  <img src={SliderImage6} alt="portfolio-example" />
                    <div className="text">
                        <p>Gas Station Construction </p>
                        <p>Check out our Portfolio</p>

                        

                        <NavLink to="/portfolio" onClick={() => scrollToTop()}>Find More</NavLink>
                    </div>  
                  </div>

                </div>
                
            </Slider>
        </div>
    )
}

export default PortfolioSlider;